import * as React from 'react';
import {FunctionComponent} from 'react';
import {StyledProps} from "../StyledProps";
import {InputAdornment} from "@material-ui/core";
import "./uji-brand.scss";
import classNames from 'classnames';
import {Menu} from "@material-ui/icons";

interface UjiBrandProps {
    toggleSidebar: () => void
}

const UjiBrand: FunctionComponent<UjiBrandProps & StyledProps> = (
    {
        style,
        className,
        toggleSidebar
    }
) => {

    const classes = classNames('uji-brand', className);

    return (
        <div className={classes}>
            <InputAdornment position="start">
                <Menu
                    data-testid={'uji-brand__hamburger-menu-logo'}
                    className={'uji-brand__hamburger-menu-logo'}
                    onClick={toggleSidebar}
                />
            </InputAdornment>

            <InputAdornment position="start">
                <img
                    src={"uji-logo.png"}
                    className={'uji-brand__uji-logo'}
                    data-testid={'uji-brand__uji-logo'}
                />
            </InputAdornment>
        </div>
    )
}

export default UjiBrand;
